import { render } from "./index.vue?vue&type=template&id=f555f87a&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=f555f87a&lang=less&rel=stylesheet%2Fless&scoped=true"
import "./index.vue?vue&type=style&index=1&id=f555f87a&lang=less&rel=stylesheet%2Fless"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f555f87a"]])

export default __exports__